import React from 'react';

interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
}

export const LogoFull: React.FC<LogoProps> = ({ className, ...props }) => (
  <img src="/kernlogic/kernlogic-logo-full.svg" alt="KernLogic" className={className} {...props} />
);

export const LogoIcon: React.FC<LogoProps> = ({ className, ...props }) => (
  <img src="/kernlogic/kernlogic-logo-icon.svg" alt="KernLogic" className={className} {...props} />
);
